import React from 'react'
import PageContainer from 'balkerne-components/Container'
import { TemplateManager } from 'balkerne-components/TemplateManager'
import { Logout } from '../components/Logout'
import Header from '../components/Header'
import { useLocation } from 'react-router-dom'
import { connect } from 'react-redux'
const TemplateManagerPage = (...props) => {
  const location = useLocation()

  return (
    <>
      <Header
        user_permissions={props[0].userData.data.permissions}
        user_portfolio_type={props[0].userData.data.portfolio_type}
        organisation={props[0].userData.data.orgid}
        customstyle={props[0].userData.data.customstyle}
        logout={() => Logout(props[0])}
      />
      <PageContainer>
        <PageContainer.centerResponsive>
          <TemplateManager {...location.state} {...props[0]} />
        </PageContainer.centerResponsive>
      </PageContainer>
    </>
  )
}

function mapStateToProps(state) {
  //console.log(state);
  const { userData, dashboardData } = state

  return {
    dashboardData,
    userData,
  }
}
export default connect(mapStateToProps)(TemplateManagerPage)
